import React, { useEffect, useState } from 'react';
import axiosPublic from '../../api/axiosPublic';

const SignedImage = ({ src, alt, expiresInMinutes = 60, ...props }) => {
  const [resolvedSrc, setResolvedSrc] = useState(src || '');

  useEffect(() => {
    let mounted = true;

    const resolve = async () => {
      if (!src) {
        if (mounted) setResolvedSrc('');
        return;
      }
      const isDataUrl = String(src).startsWith('data:');
      const isBlobUrl = String(src).startsWith('blob:');
      const srcStr = String(src);
      const isHttpUrl = /^https?:\/\//i.test(srcStr);
      const isS3Url = /^https?:\/\/[^/]+\.s3[.-].*amazonaws\.com\//i.test(srcStr);
      const shouldSignDirectUrl =
        isS3Url &&
        !srcStr.includes('/public/') &&
        (srcStr.includes('/skhool/local/') || srcStr.includes('/schools/'));
      const isSignedUrlEndpoint = srcStr.includes('/api/images/signed-url');
      if (isDataUrl || isBlobUrl) {
        if (mounted) setResolvedSrc(src);
        return;
      }
      if (isHttpUrl && !isSignedUrlEndpoint && !shouldSignDirectUrl) {
        if (mounted) setResolvedSrc(src);
        return;
      }
      if (isSignedUrlEndpoint) {
        try {
          const parsed = new URL(srcStr);
          const fileParam = parsed.searchParams.get('file');
          if (fileParam) {
            if (mounted) setResolvedSrc(fileParam);
            return;
          }
        } catch {
          // fall through to original behavior
        }
        if (mounted) setResolvedSrc(src);
        return;
      }
      const signedUrl = await axiosPublic.getSignedUrl(src, expiresInMinutes);
      if (mounted) {
        setResolvedSrc(signedUrl || src);
      }
    };

    resolve();
    return () => {
      mounted = false;
    };
  }, [src, expiresInMinutes]);

  return <img src={resolvedSrc} alt={alt} {...props} />;
};

export default SignedImage;
